module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAABFklEQVR4AbTVNVYtURSE4e73cNcInQYu0yAlI0Ei3OIb4TIAyEhxjdEcd3eHopCN037+tb701JUWDYCRYCqgXlqiRwK7oXlqo3zS/zrjr4P/UxHtwlozlG91IJaG4Swf/TcaiKcFuKvn88j3n2Uc3uT7baAE3pb3eSCM9uFtM6TLQCHUlCsDfVBTswysQU3zMqCqaw2ADoVpb/agpl0ZmIKaxmSgFmqqkIEUuoe33VGiDBC64W1d359FUbQBb9qgqM8DIp3uPPhp0o1eOGVwV5nZG02nAThrgHSjAZFKV7DXFaVaeSeLRtirkTQ7A1F0AmudUJSdAdECa7WQ5mQgE9bKdDrgR5cw7pL8nAyIp90gYMENfPoBLZSsMkIH4y4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ideate/bulb.png
// module id = 180
// module chunks = 35783957827783 112966903596346 114276838955818